import { render, staticRenderFns } from "./DemoCaseTabs.vue?vue&type=template&id=8d141e58&scoped=true&"
import script from "./DemoCaseTabs.vue?vue&type=script&lang=js&"
export * from "./DemoCaseTabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d141e58",
  null
  
)

export default component.exports